<template>
  <div class="my-4">
    <div
      v-for="(list, key) in dataLists"
      :key="key"
      class="border-b border-blue-chill md:pr-4"
    >
      <button
        type="button"
        class="py-4 w-full flex items-center justify-between text-left"
        :class="{ 'text-primary': checkIfOpen(list.id) }"
        @click="toggleAccordion(list.id)"
      >
        <div class="font-bold text-blog-17-sm md:text-lg leading-relaxed">
          {{ list.title }}
        </div>
        <span class="ml-6 flex items-center w-4 md:w-auto flex-shrink-0">
          <NuxtImg
            v-if="!checkIfOpen(list.id)"
            loading="lazy"
            src="/icons/ctrl-down.svg"
            alt="Down arrow"
            width="24"
            height="12"
          />
          <NuxtImg
            v-else
            loading="lazy"
            src="/icons/ctrl-down.svg"
            class="rotate-180"
            alt="Down arrow"
            width="24"
            height="12"
          />
        </span>
      </button>

      <div
        class="pb-12 leading-7 text-left disclosure-body grid grid-cols-2 gap-4"
        :class="{ hidden: !checkIfOpen(list.id) }"
      >
        <div
          v-for="(item, key) in list.cities"
          :key="key"
          class="text-lg-30 font-semibold text-secondary underline tracking-wide cursor-pointer"
        >
          <NuxtLinkLocale
            :locale="switchBlogLocale()"
            :to="`/clinics/${item.slug}`"
          >
            {{ item.title }}
          </NuxtLinkLocale>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  dataLists: Array,
});

const isOpen = ref({});

const toggleAccordion = (id) => {
  isOpen.value[id] = !checkIfOpen(id);
};

const checkIfOpen = (id) => {
  return Boolean(isOpen.value[id]);
};
</script>
